import { useEffect, useMemo, useState } from "react";
import eventsLocal from "../data/events";
import apiService from "../services/api";

export function useCategorizedEvents(categoryId, linkPrefix) {
  const [data, setData] = useState(eventsLocal);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let isMounted = true;

    async function fetchEvents() {
      try {

        const json = await apiService.getEvents();
        
        const normalized = json.data
          .filter((e) => e.categories?.id === categoryId && e.status?.id === 1)
          .map((e) => {
            const dateObj = new Date(e.event_date);

            return {
              id: e.id,
              title: e.title,
              year: dateObj.getFullYear(),
              event_date: dateObj.toLocaleDateString(),
              location: e.place,
              link: `/${linkPrefix}/id/${e.event_public_id}`,
              dateRaw: dateObj,
            };
          });

        if (isMounted) setData(normalized);
      } catch (err) {
        console.warn(err);
        if (isMounted) {
          setError(err.message);
          setData(eventsLocal);
        }
      } finally {
        if (isMounted) setLoading(false);
      }
    }

    fetchEvents();

    return () => {
      isMounted = false;
    };
  }, [categoryId, linkPrefix]);

  const sorted = useMemo(() => {
    return [...data].sort(
      (a, b) => b.year - a.year || a.title.localeCompare(b.title)
    );
  }, [data]);

  return { data: sorted, loading, error };
}
